enum ActionTypes {
    GET_PROJECT_APPROVALS = "approvals/getProjectApprovals",
    GET_PROJECT_APPROVALS_SUCCESS = "approvals/getProjectApprovalsSuccess",
    GET_PROJECT_APPROVALS_FINISH = "approvals/getProjectApprovalsFinish",
    GET_PROJECT_AI_REVIEW_TWEAK = "approvals/getProjectAIReviewTweak",

    GET_WORKSPACE_APPROVALS = "approvals/getWorkspaceApprovals",
    GET_WORKSPACE_APPROVALS_SUCCESS = "approvals/getWorkspaceApprovalsSuccess",

    CREATE_APPROVAL = "approvals/createApproval",
    CREATE_APPROVAL_SUCCESS = "approvals/createApprovalSuccess",
    CREATE_APPROVAL_FAILURE = "approvals/createApprovalFailure",
    ADD_APPROVAL = "approvals/addApproval",

    UPDATE_APPROVAL = "approvals/updateApproval",
    UPDATE_APPROVAL_SUCCESS = "approvals/updateApprovalSuccess",
    UPDATE_APPROVAL_FAILURE = "approvals/updateApprovalFailure",

    UPDATE_APPROVAL_REVIEW = "approvals/updateApprovalReview",
    UPDATE_APPROVAL_REVIEW_SUCCESS = "approvals/updateApprovalReviewSuccess",
    UPDATE_APPROVAL_REVIEW_FAILURE = "approvals/updateApprovalReviewFailure",

    RE_REQUEST_APPROVAL_REVIEW = "approvals/reRequestApprovalReview",
    RE_REQUEST_APPROVAL_REVIEW_SUCCESS = "approvals/reRequestApprovalReviewSuccess",
    RE_REQUEST_APPROVAL_REVIEW_FAILURE = "approvals/reRequestApprovalReviewFailure",

    DELETE_APPROVAL_REVIEWER = "approvals/deleteApprovalReviewer",
    DELETE_APPROVAL_REVIEWER_SUCCESS = "approvals/deleteApprovalReviewerSuccess",
    DELETE_APPROVAL_REVIEWER_FAILURE = "approvals/deleteApprovalReviewerFailure",

    DELETE_APPROVAL = "approvals/deleteApproval",

    ADD_WORKSPACE_APPROVAL = "approvals/addWorkspaceApproval",
    UPDATE_WORKSPACE_APPROVAL = "approvals/updateWorkspaceApproval",
    UPDATE_WORKSPACE_APPROVAL_REVIEW = "approvals/updateWorkspaceApprovalReview",
    DELETE_WORKSPACE_APPROVAL_REVIEWER = "approvals/deleteWorkspaceApprovalReviewer",
    DELETE_WORKSPACE_APPROVAL = "approvals/deleteWorkspaceApproval",

    CREATE_AI_REVIEW = "approvals/createAIReview",
    CREATE_AI_REVIEW_SUCCESS = "approvals/createAIReviewSuccess",
    CREATE_AI_REVIEW_FAILURE = "approvals/createAIReviewFailure",
    RETRY_AI_REVIEW = "approvals/retryAIReview",
    UPDATE_AI_REVIEW = "approvals/updateAIReview",
    CREATE_AI_REVIEW_FEEDBACK = "approvals/createAiReviewFeedback",
    DELETE_AI_REVIEW_FEEDBACK = "approvals/deleteAiReviewFeedback",
    UPDATE_AI_REVIEW_STATUS = "approvals/updateAIReviewStatus",
    UPDATE_AI_REVIEW_SCREEN_STATUS = "approvals/updateAIReviewScreenStatus",
    UPDATE_AI_REVIEW_SCREEN_CATEGORY_STATUS = "approvals/updateAIReviewScreenCategoryStatus",
    CREATE_AI_REVIEW_SCREEN_DOT = "approvals/createAIReviewScreenDot",
    CREATE_AI_REVIEW_SCREEN_DOT_RATING = "approvals/createAIReviewScreenDotRating",
    UPDATE_AI_REVIEW_SCREEN_DOT = "approvals/updateAIReviewScreenDot",
    UPDATE_AI_REVIEW_SCREEN_DOT_STATUS = "approvals/updateAIReviewScreenDotStatus",
    DELETE_AI_REVIEW_SCREEN_DOT = "approvals/deleteAIReviewScreenDot",
    DELETE_AI_REVIEW = "approvals/deleteAIReview",
    STOP_AI_REVIEW = "approvals/stopAIReview",
}

export default ActionTypes;
